<template>
    <div :class="className" :style="{height:height,width:width}"></div>
</template>

<script>
import echarts from "echarts";
/* 


  切记，这个组件已经变成饼图了 并不是Ring
  
 */
export default {
  props: {
    className: {
      type: String,
      default: "pieRingChart"
    },
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: "300px"
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Object
    }
  },
  data() {
    return {
      chart: null
    };
  },
  mounted() {
    this.initChart();
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      }
    }
  },
  methods: {
    setOptions({ expectedData, actualData } = {}) {
      this.chart.setOption({
        series: [
          {
            name: "访问来源",
            type: "pie",
            radius: "70%",
            color:['#67C23A','#909399'],
            avoidLabelOverlap: false,
            startAngle: 90,
            label: {
              normal: {
                show: false,
                position: "right",
                color:"#000"
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: "18",
                  fontWeight: "bold"
                }
              }
            },
            labelLine: {
              normal: {
                show: true
              }
            },
            data: [{ value: expectedData.val , name: expectedData.name }, { value: actualData.val, name: actualData.name}]
          }
        ]
      });
    },
    initChart() {
        this.chart = echarts.init(this.$el)
        this.setOptions(this.chartData)
    }
  }
};
</script>
<style lang="scss" scoped>

</style>




// WEBPACK FOOTER //
// src/components/pieRingEchart.vue